/**
 * Labstep
 *
 * @module components/Resource/Action/Duplicate
 * @desc Duplicate action for resource
 */

import { EntityActionDuplicate } from 'labstep-web/components/Entity/Action/Duplicate';
import type React from 'react';
import type { IResourceActionDuplicateProps } from './types';

export const ResourceActionDuplicate: React.FC<
  IResourceActionDuplicateProps
> = ({ resource }) => <EntityActionDuplicate entity={resource} />;
